import { FileReference } from '@kaizenplatform/belfast-entity';

import State from '../core/State';
import { GetOfferByIdQuery } from '../graphql/generated/graphql_offer';
import initialState from '../initialState';

export const startFetchingOffer = () => (state: State): State => ({
  ...state,
  offer: {
    ...state.offer,
    fetching: state.offer.fetching + 1,
  },
});

export const finishFetchingOffer = () => (state: State): State => ({
  ...state,
  offer: {
    ...state.offer,
    fetching: state.offer.fetching - 1,
  },
});

export const setOffer = (offer: GetOfferByIdQuery['offer']) => (state: State): State => ({
  ...state,
  offer: {
    ...state.offer,
    offer,
  },
});

export const setOfferWithFiles = (
  offer: GetOfferByIdQuery['offer'],
  assetFiles: ReadonlyArray<FileReference>,
  briefFiles: Map<string, FileReference[]>,
) => (state: State): State => ({
  ...state,
  offer: {
    ...state.offer,
    offer,
    assetFiles,
    briefFiles,
  },
});

export const startMutatingOffer = () => (state: State): State => ({
  ...state,
  offer: {
    ...state.offer,
    mutating: state.offer.mutating + 1,
  },
});

export const finishMutatingOffer = () => (state: State): State => ({
  ...state,
  offer: {
    ...state.offer,
    mutating: state.offer.mutating - 1,
  },
});

export const dispose = () => (state: State): State => ({
  ...state,
  offer: {
    ...state.offer,
    offer: initialState.offer.offer,
    briefFiles: initialState.offer.briefFiles,
  },
});
